function checkForLocalStorage(
  fnc: Function,
  name: string,
  descriptor: PropertyDescriptor
): any {
  const method = descriptor.value;
  descriptor.value = function(...args) {
    try {
      if (localStorage) { return method.apply(this, args); }
    } catch {
      console.log('localStorage disabled');
      return undefined;
    }
  };
}

export class Storage {
  @checkForLocalStorage
  static get(name) {
    return JSON.parse(localStorage.getItem(name));
  }
  @checkForLocalStorage
  static set(name, data) {
    localStorage.setItem(name, JSON.stringify(data));
  }
  @checkForLocalStorage
  static del(name) {
    localStorage.removeItem(name);
  }
}
